import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfesorGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate() {
    console.log('🔒 ProfesorGuard: Verificando acceso...');
    return this.authService.currentUser.pipe(
      take(1),
      map(user => {
        console.log('🔒 ProfesorGuard: Usuario actual:', user);
        if (user && user.rol === 'profesor') {
          console.log('🔒 ProfesorGuard: Acceso permitido para profesor');
          return true;
        }
        console.log('🔒 ProfesorGuard: Acceso denegado, redirigiendo a login');
        this.router.navigate(['/login']);
        return false;
      })
    );
  }
} 